export default "__VITE_ASSET__86b9a296__"